import { render } from "./AnnexAlarmAcknowledgeInfo.vue?vue&type=template&id=9a65e044&ts=true"
import script from "./AnnexAlarmAcknowledgeInfo.vue?vue&type=script&lang=ts"
export * from "./AnnexAlarmAcknowledgeInfo.vue?vue&type=script&lang=ts"

import "./AnnexAlarmAcknowledgeInfo.vue?vue&type=style&index=0&id=9a65e044&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__